import React, { useEffect, useState, useRef } from 'react';
import {
  Wrapper,
  Menu,
  Button,
  MenuItem,
  openMenu,
} from 'react-aria-menubutton';
import styled from 'styled-components/macro';
import { getUrl } from '../../../utils/index';
import Link from './Link';
import {responsive} from '../../../resources/constantes.json'

import ArrowIcon from '../../svg/Arrow';
const Dropdown = ({
  items,
  defaultButtonText,
  eleccion,
  nomenclator,
  className = '',
  defaultSelectedId,
  hasSelectedItem,
  openOnMount,
  page,
  onSelection = () => {},
  variant = 'desktop',
  parentLevel,
  selectedMesa,
	isFullH
}) => {
  const [isOpen, setIsOpen] = useState(openOnMount);
  const [selectedId, setSelectedId] = useState(defaultSelectedId);

  const wrapperId = `menu-wrapper-level-${items[0].i}`;

  //lo del isMountedRef: openMenu es asíncrono. Si desmontamos el dropdown entre que lo llamamos y lo hace da error.
  const isMountedRef = useRef(true);
  useEffect(() => {
    if (isMountedRef.current) {
      openOnMount && openMenu(wrapperId, { focusMenu: false });
    }
    return () => (isMountedRef.current = false);
  }, [openOnMount, wrapperId]);

  const item =
    hasSelectedItem && selectedId && items.find(x => x.i === selectedId);
  const texto = item ? item.n : defaultButtonText;

  return (
    <Wrapper
      onSelection={id => {
        setSelectedId(id);
        onSelection({
          id,
          eleccion,
          nomenclator,
          page,
          parentLevel,
          selectedMesa,
        });
      }}
      className={className}
      closeOnBlur={false}
      id={wrapperId}
      onMenuToggle={({ isOpen }) => setIsOpen(isOpen)}
    >
      <StyledButton>
        <span>{texto}</span>
        <ArrowIcon variant={isOpen ? 'up' : 'down'} fill="#1c4183" />
      </StyledButton>
      <Menu>
        <Ul isFullH={isFullH}>
          {items.map(ambito => (
            <li key={ambito.i}>
              <SMenuItem value={ambito.i} isFullH={isFullH}>
                {variant === 'desktop' ? (
                  <Link
                    to={getUrl({
                      id: ambito.i,
                      eleccion,
                      nomenclator,
                      page,
                      parentLevel,
                    })}
                    tabIndex="-1"
                    selected={selectedId === ambito.i}
                    css={`
                      font-weight: ${({ selected }) => selected && 'bold'};
                    `}
                  >
                    {ambito.n}
                  </Link>
                ) : (
                  <span
                    selected={selectedId === ambito.i}
                    css={`
                      font-weight: ${({ selected }) => selected && 'bold'};
                      font-size: 14px;
                    `}
                  >
                    {ambito.n}
                  </span>
                )}
              </SMenuItem>
            </li>
          ))}
        </Ul>
      </Menu>
    </Wrapper>
  );
};
export default Dropdown;

const StyledButton = styled(Button)`
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  padding: 20px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
`;
const Ul = styled.ul`
  max-height: 260px;
  overflow: auto;
  background: white;
  margin-bottom: 20px;
	${({isFullH}) => isFullH && ` 
		& > li:last-child{
			padding-bottom: 50px;
		}
	`}
`;

const SMenuItem = styled(MenuItem)`
  cursor: pointer;
  ${({isFullH}) => isFullH && ` 
		padding: 10px 0;
	`}

  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
`;
